module.exports = __webpack_public_path__ + "static/media/PATS_7-1920w.f9d33fcf.png";